/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PublishHouseMainDto from './PublishHouseMainDto';

/**
 * The PublishHouseDto model module.
 * @module model/PublishHouseDto
 * @version v1.0.0
 */
class PublishHouseDto {
    /**
     * Constructs a new <code>PublishHouseDto</code>.
     * @alias module:model/PublishHouseDto
     */
    constructor() { 
        
        PublishHouseDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PublishHouseDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PublishHouseDto} obj Optional instance to populate.
     * @return {module:model/PublishHouseDto} The populated <code>PublishHouseDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PublishHouseDto();

            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('main')) {
                obj['main'] = PublishHouseMainDto.constructFromObject(data['main']);
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} code
 */
PublishHouseDto.prototype['code'] = undefined;

/**
 * @member {String} description
 */
PublishHouseDto.prototype['description'] = undefined;

/**
 * @member {String} id
 */
PublishHouseDto.prototype['id'] = undefined;

/**
 * @member {module:model/PublishHouseMainDto} main
 */
PublishHouseDto.prototype['main'] = undefined;

/**
 * @member {String} name
 */
PublishHouseDto.prototype['name'] = undefined;

/**
 * @member {Number} seq
 */
PublishHouseDto.prototype['seq'] = undefined;






export default PublishHouseDto;

